import { Buffer } from 'buffer'
import { inflate } from 'pako'

import { LanguageCode } from '../constants/language-codes'
import { languages } from '../constants/languages'
import { LinkedResource, MedicalId } from '../types'

export const transformV3 = (
  urlString: string
): { medicalId: MedicalId; tagId: string | null } => {
  const url = new URL(urlString)
  const payload = url.searchParams.get('payload') ?? ''
  const decodedBase64 = Buffer.from(payload, 'base64')
  const uint8 = new Uint8Array(decodedBase64)
  const inflatedPayload = inflate(uint8, { to: 'string' })

  const minified = JSON.parse(inflatedPayload) ?? []

  const language1 = languages.find(({ name }) => name === minified[41])
  const language2 = languages.find(({ name }) => name === minified[42])
  const language3 = languages.find(({ name }) => name === minified[43])

  const payloadLanguages: LanguageCode[] = []
  if (language1) {
    payloadLanguages.push(language1.code)
  }

  if (language2) {
    payloadLanguages.push(language2.code)
  }

  if (language3) {
    payloadLanguages.push(language3.code)
  }

  const emergencyContacts = []
  if (minified[1]) {
    emergencyContacts.push({
      name: minified[1],
      relationship: minified[4],
      phoneNumber: minified[7],
      countryCode: minified[10],
    })
  }

  if (minified[2]) {
    emergencyContacts.push({
      name: minified[2],
      relationship: minified[5],
      phoneNumber: minified[8],
      countryCode: minified[11],
    })
  }

  if (minified[3]) {
    emergencyContacts.push({
      name: minified[3],
      relationship: minified[6],
      phoneNumber: minified[9],
      countryCode: minified[12],
    })
  }

  const links: LinkedResource[] = []

  if (minified[64]) {
    links.push({
      label: 'Work Document',
      url: minified[64],
    })
  }

  if (minified[65]) {
    links.push({
      label: 'Work Document 2',
      url: minified[65],
    })
  }

  const _fullName = minified[67]
  const medicalId: MedicalId = {
    id: '',
    fullName: _fullName ?? `${minified[26] ?? ''} ${minified[27] ?? ''}`.trim(),
    dateOfBirth: minified[0],
    gender:
      minified[28] === 'man'
        ? 'male'
        : minified[28] === 'woman'
        ? 'female'
        : undefined,
    nationality: minified[48],
    languages: payloadLanguages,
    emergencyContacts,
    chronicConditions: minified[47],
    pacemaker: minified[54],
    organDonor: minified[53],
    religion: minified[56],
    eyeColor: minified[25],
    systemOfMeasurement: minified[29] === 'cm/kg' ? 'metric' : 'imperial',
    height: minified[30],
    weight: minified[31],
    identificationCharacteristics: minified[32],
    insuranceCompanyName: minified[34],
    insuranceNumber: minified[33],
    insurancePhoneNumber: minified[35],
    insurancePhoneNumberCountryCode: minified[36],
    passportNumber: minified[55],
    ssn: minified[66],
    linkedResources: links,
  }

  const tagId = minified[68] ?? null
  return {
    medicalId,
    tagId,
  }
}
